<template>
  <!-- eslint-disable -->
  <div class="audio-form-step">
    <div>BUTTON</div>
    <div>
      <v-text-field
        class="panzoom-ignore mb-3"
        v-model="node.data.text"
        :label="'Text'"
        persistent-placeholder
        hide-details="auto"
        :placeholder="'Text'"></v-text-field>

      <v-text-field
        class="panzoom-ignore mb-3"
        v-model="node.data.link"
        :label="'Link'"
        persistent-placeholder
        hide-details="auto"
        :placeholder="'Link'"></v-text-field>

      <v-select
        class="mb-3"
        v-model="node.data.type"
        :label="'Button type'"
        :items="buttonTypes"
        hide-details="auto"
        :menu-props="{
          offsetOverflow: true,
          offsetY: true,
        }">
      </v-select>

      <v-checkbox
        v-if="node.data.type === 'primary'"
        class="mb-2"
        :label="'Display check icon'"
        v-model="node.data.checkIcon"
        color="primary"
        hide-details="auto">
      </v-checkbox>

      <v-checkbox
        v-if="node.data.type === 'secondary'"
        class="mb-2"
        :label="'Display X icon'"
        v-model="node.data.closeIcon"
        color="primary"
        hide-details="auto">
      </v-checkbox>
    </div>

    <div><v-btn v-if="displayAddItemBtn" @click="addItem">Add Step</v-btn></div>
  </div>
</template>

<script>
  import { STEP } from "./constant";
  import cloneDeep from "lodash/cloneDeep";

  export default {
    name: "AudioFormButton",
    props: {
      node: {
        type: Object,
        required: true,
      },
      tree: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        buttonTypes: ["primary", "secondary", "CTA"],
      };
    },
    computed: {
      displayAddItemBtn() {
        return this.node.children.length < 1;
      },
    },
    methods: {
      addItem() {
        this.tree.addNode(this.node, cloneDeep(STEP));
      },
    },
  };
</script>

<style lang="scss" scoped></style>
